import React from "react";
import { FormattedMessage } from "react-intl";
import { Paragraph } from "@trainline/depot-web";
import { spacers } from "@trainline/depot-web/css";
import { getTimeUnitsInHoursAndMinutes } from "@trainline-shareable/utils";
import IconConnectionLeg from "../../assets/icons/IconConnectionLeg";
import useJourneyPlan from "../../hooks/useJourneyPlan";
import getLegConnection from "../../utils/legs/getLegConnection";
import TrackItem from "../TrackItem";
const getMessageId = ({ isSameStation, durationInMs }) => {
  const baseMessageId = isSameStation ? "connectionLeg.connectionTime" : "connectionLeg.connectionTimeWithStationChange";
  const messageTimeSuffix = durationInMs >= 60 * 60 * 1e3 ? "inHoursAndMinutes" : "inMinutes";
  return `${baseMessageId}.${messageTimeSuffix}`;
};
const ConnectionLeg = ({ legId }) => {
  const { legs } = useJourneyPlan();
  const connection = getLegConnection(legId, legs);
  if (!connection || !connection.durationInMs) {
    return null;
  }
  const { hours, minutes } = getTimeUnitsInHoursAndMinutes(connection.durationInMs);
  return /* @__PURE__ */ React.createElement(TrackItem, {
    style: { marginBottom: "-24px" }
  }, /* @__PURE__ */ React.createElement(TrackItem.Marker, null, /* @__PURE__ */ React.createElement(IconConnectionLeg, null)), /* @__PURE__ */ React.createElement(TrackItem.Time, null), /* @__PURE__ */ React.createElement(TrackItem.Info, {
    style: { padding: `${spacers.dp_s32} 0` }
  }, /* @__PURE__ */ React.createElement(Paragraph, {
    as: "span",
    typeStyle: "body",
    color: "subtle"
  }, /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: getMessageId(connection),
    values: { hours, minutes }
  }))));
};
var ConnectionLeg_default = ConnectionLeg;
export {
  ConnectionLeg,
  ConnectionLeg_default as default
};
